export default [
  {
    title: 'Inicio',
    route: 'dashboard',
    icon: 'HomeIcon',
  },
  {
    title: 'Partes de horas',
    route: 'parts',
    icon: 'ServerIcon',
  },
  {
    title: 'Trazabilidad',
    route: 'traceabilitiesLogs',
    icon: 'ActivityIcon',
  },
  {
    title: 'Obras',
    icon: 'CheckSquareIcon',
    children: [
      {
        title: 'Listado obras',
        route: 'obras',
      },
      {
        title: 'Trabajos',
        route: 'jobs',
      },
    ],
  },
]
